import './stage.scss';

class StageTeasers {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-stage-teasers',
            slidesAttr: 'slides',
            slideAttr: 'slide',
            minSlidesDesktop: 3,
            minSlidesMobile: 2
        };

        this.settings = Object.assign({}, settings, options);

        this.$stageTeasers = element;
        this.$slides = this.$stageTeasers.querySelector('[' + this.settings.initAttr + '="' + this.settings.slidesAttr + '"]');
        this.$$slides = this.$stageTeasers.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.slideAttr + '"]');
        this.slider = null;

        this.initialize();
    }

    initialize () {
        import ('../../components/slider/slider').then(({ Slider }) => {
            this.Slider = Slider;
            this.toggleSlider();

            window.mediaMatchHandler[768].addEventListener('change', () => {
                this.toggleSlider();
            });
        });
    }

    toggleSlider () {
        const minSlides = window.mediaMatchHandler[768].matches ? this.settings.minSlidesDesktop : this.settings.minSlidesMobile;
        const wantsSlider = this.$$slides.length >= minSlides;

        if (wantsSlider && !this.slider) {
            this.slider = new this.Slider(this.$stageTeasers, {
                initAttr: this.settings.initAttr,
                calculateHeight: false,
                slidesPerView: 'auto',
                breakpoints: {}
            });
        } else if (!wantsSlider && this.slider) {
            this.destroySlider();
        }
    }

    destroySlider () {
        this.slider.slider?.destroy(true, true);

        this.$$slides.forEach(($slide) => {
            $slide.classList.remove('swiper-slide');
            $slide.removeAttribute('data-swiper-slide-index');
            this.$slides.appendChild($slide);
        });

        this.$slides.querySelectorAll('.swiper-container, .swiper-controls').forEach(($el) => $el.remove());
        Array.from(this.$slides.classList).filter((name) => name.startsWith('swiper-')).forEach((name) => this.$slides.classList.remove(name));

        this.slider = null;
    }
}

export { StageTeasers };

window.addEventListener('content.loaded', (e) => {
    const context = e.detail.$context;

    if (context) {
        const $$stageTeasers = context.querySelectorAll('[data-stage-teasers="root"]');

        $$stageTeasers.forEach(($stageTeasers) => {
            $stageTeasers.stageTeasersAPI = new StageTeasers($stageTeasers);
        });
    }
});
